<template>

 <div class="">

   <b-overlay
     :show="show"
     spinner-variant="primary"
     spinner-large
     rounded="sm"
     style="height:100vh"
     variant="dark"
     id="loader"
   >


   <b-container fluid style="padding-top: 100px;text-align:left">
       <b-row>
         <b-col cols="12 headerF"><HeaderConsumer/></b-col>
         <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
       </b-row>

        <br><br><br>

        <b-row style="padding-bottom:0px;text-align:center">
          <b-col cols=12>
            <span id="configDiv">Demo</span><br>
            Consumer No: <select class="customSelect" id="consList" @change="switchConsumer()"> </select>
           <br> <span id="responseDiv">Demo</span><br>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
    <b-modal id="redirectModal" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="redirectModalMsg" style="color:red">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="redirect()">OK</b-button>
    </b-modal>
    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>
 </div>

</template>


<script>
import Chart from 'chart.js';
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

var checked = 0;
var thColor = '#0288d1';
var oldMob="";
var click = [];
var accessToken="";
var consList;
Vue.use(Vuex)


export default {
 name: 'ConsumerDashboard',
 components: {

   'HeaderConsumer' : HeaderConsumer,
   'HeaderConsumerMobile' : HeaderConsumerMobile

 },
 data() {
     return {
         show: false,
         show1: false,
         messageToSend:"",
         reqUrl:"",
         selected: null,
       }

 },

 methods:
 {
redirect(){
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("consList");
      sessionStorage.removeItem("selectedCons");
      window.location.href = "/website/";
      return false;
},
   switchConsumer()
   {
     this.show=true;
     var consNo = document.getElementById("consList").value;
     
     var consType;
     
     var parent= this;
     let data = JSON.stringify({
        "consNo": consNo
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/auth/getConsDetails',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
        data : data
      };
      var parent=this;
      axios.request(config)
      .then((response) => {
        parent.show=false;
        console.log(response.data);
        if(response.data.message=="00")
          {
          sessionStorage.setItem("selectedCons", consNo);
          consType = response.data.connType;
          console.log("type:::"+consType);
          if(consType == "POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardPostpaid";
                return false;
        
              }
          else if( consType == "SMART POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                return false;
        
              }
          else  if(consType == "PREPAID")
              {
                window.location.href = "/website/ConsumerDashboardPrepaid";
                return false;
               
              }
          else  if(consType == "SMART PREPAID")
              {
                window.location.href="/website/ConsumerDashboardSmartPrepaid";
                return false;
               
              }
          }
        else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }
      })
      .catch((e) => {
        parent.show=false;
        console.log("Caught :::::::::::::::", e.message);
        if(e.message=="Network Error")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }
      });

   }
 },
 mounted()
 {

  if (sessionStorage.getItem("accessToken")) {
    accessToken = sessionStorage.getItem("accessToken");
    var consNo = sessionStorage.getItem("selectedCons");
    var mobile =sessionStorage.getItem("mobile");
    consList = JSON.parse(sessionStorage.getItem("consList"));
   
    
    var consType;
      
      let data1 = JSON.stringify({
                "consNo": consNo,
                "mobileNo":mobile
              });

              let config1 = {
                method: 'post',
                maxBodyLength: Infinity,
                 url: this.$urlCommon+'/api/web/auth/getConsDetails',
               
                headers: { 
                  'Authorization': accessToken, 
                  'Content-Type': 'application/json'
                },
                data : data1
              };
              document.getElementById("configDiv").innerHTML=JSON.stringify(config1);
             
      axios.request(config1)
      .then((response) => {
        //parent.show=false;
        console.log(response.data);
        document.getElementById("responseDiv").innerHTML=JSON.stringify((response.data));
        if(response.data.message=="00")
          {
        //  sessionStorage.setItem("selectedCons", consNo);
          consType = response.data.connType;
          if(consType == "POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardPostpaid";
                return false;
              }
          else  if(consType == "SMART POSTPAID")
              {
                window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                return false;
              }
          else  if(consType == "PREPAID")
              {
                window.location.href = "/website/ConsumerDashboardPrepaid";
                return false;
               
              }
          else  if(consType == "SMART PREPAID")
              {
                window.location.href="/website/ConsumerDashboardSmartPrepaid";
                return false;
               
              }
          }
        else{
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Consumer Not Found";
        }
      })
      .catch((e) => {
       // parent.show=false;
        document.getElementById("responseDiv").innerHTML=e;
        console.log("Caught :::::::::::::::", e.message);

        if(e.message=="Network Error")
        {
          parent.$bvModal.show('redirectModal');
          document.getElementById("redirectModalMsg").innerHTML="Session Expired, Please log in again";
        }
      });
    return;
    if(parseInt(consList.length)>0)
      {
        consList.forEach(element => {
        var option1 = document.createElement("option");
        option1.text = element;
        option1.value = element;
        var select1 = document.getElementById("consList");
        select1.appendChild(option1);
        })
      this.switchConsumer();
     }
    else {
      this.$bvModal.show('model');
       document.getElementById("modalMsg").innerHTML="No Consumer Mapped to This Mobile number";
       
     }
  }
    else
     {
       this.$router.push({ path: '/' })
       return;
     }

 
}
}

</script>


<style scoped="true">

.label{
font-weight:600;
}
.customSelect
{

border: 1px solid #039be5 ;
color: #0277bd    ;
border-radius: 5px;
height: 1.8rem;
width: 10rem;
font-weight: 600;

}
.customSelect:hover
{
cursor:pointer;
border: 2px solid #039be5;
color: #1565c0  ;
border-radius: 5px;
height: 1.8rem;
width: 10rem;
font-weight: 600;
}
.modalFont{
 width: 100px;
 display: block;
 margin: 40px auto 0;
}

.path {
 stroke-dasharray: 1000;
 stroke-dashoffset: 0;
}
.path.circle {
 -webkit-animation: dash 0.9s ease-in-out;
 animation: dash 0.9s ease-in-out;
}
.path.line {
 stroke-dashoffset: 1000;
 -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
 animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
 stroke-dashoffset: -100;
 -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
 animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
 text-align: center;
 margin: 20px 0 60px;
 font-size: 1.25em;
}
p.success {
 color: #73AF55;
}
p.error {
 color: #D06079;
}
@-webkit-keyframes dash {
 0% {
   stroke-dashoffset: 1000;
 }
 100% {
   stroke-dashoffset: 0;
 }
}
@keyframes dash {
 0% {
   stroke-dashoffset: 1000;
 }
 100% {
   stroke-dashoffset: 0;
 }
}
@-webkit-keyframes dash-check {
 0% {
   stroke-dashoffset: -100;
 }
 100% {
   stroke-dashoffset: 900;
 }
}
@keyframes dash-check {
 0% {
   stroke-dashoffset: -100;
 }
 100% {
   stroke-dashoffset: 900;
 }
}
.headerF{
 display: block;
}
.headerM{
 display: none;
}
.OnlinePaymentCardStyle{
 padding:0;
 box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;
 width:30%;
 margin-left:35%;
 text-align:center;
 min-height:50vh;
}
.marginTop{
 margin-top: -10px;
}
.marginTop20px{
 margin-top: none;
}
@media (max-width: 768px) {
   .headerF{
     display: none;
   }
   .headerM{
     display: block;
   }
   .OnlinePaymentCardStyle{
     width:50%;
     margin-left:25%;
   }
   .marginTop{
     margin-top: 20px;
   }
   .marginTop20px{
     margin-top: 20px;
   }
 }
@media (max-width: 576px) {
 .OnlinePaymentCardStyle{
   width:80%;
   margin-left:10%;
 }
 .marginTop20px{
   margin-top: 20px;
 }
}
</style>
